/* ============================================================
   MUDNAAZ — Complete The Look (CTL) Bundle System
   ============================================================ */
(function () {
  'use strict';

  const CTL = {
    section: null,
    grid: null,
    bar: null,
    selected: new Map(),
    productId: null,
    discount: 0,

    init() {
      this.section = document.querySelector('.mn-ctl-section');
      if (!this.section) return;
      this.grid  = this.section.querySelector('#mn-ctl-grid');
      this.bar   = document.getElementById('mn-ctl-bundle-bar');
      this.productId = this.section.dataset.productId;
      this.discount  = parseInt(this.section.dataset.discount || '0', 10);
      this.showSkeletons(parseInt(this.section.dataset.limit || '4', 10));
      this.fetchRecs();
      this.bindBar();
    },

    showSkeletons(n) {
      this.grid.innerHTML = Array(n).fill(0).map(() =>
        '<div class="mn-ctl-skeleton">'
        + '<div class="mn-ctl-sk-img"></div>'
        + '<div class="mn-ctl-sk-body">'
        + '<div class="mn-ctl-sk-line"></div>'
        + '<div class="mn-ctl-sk-line short"></div>'
        + '<div class="mn-ctl-sk-line price"></div>'
        + '</div></div>'
      ).join('');
    },

    async fetchRecs() {
      try {
        const lim = parseInt(this.section.dataset.limit || '4', 10);
        const url = '/recommendations/products.json?product_id=' + this.productId + '&limit=10&intent=related';
        const r = await fetch(url);
        if (!r.ok) throw new Error();
        const data = await r.json();
        let products = data.products || [];

        // Filter out same product type (prefer accessories/complementary)
        const curType = (this.section.dataset.productType || '').toLowerCase();
        const filtered = products.filter(p => (p.product_type || '').toLowerCase() !== curType);
        products = filtered.length >= 2 ? filtered : products;
        products = products.slice(0, lim);

        if (products.length > 0) {
          this.renderProducts(products);
        } else {
          this.showEmpty();
        }
      } catch(e) {
        this.showEmpty();
      }
    },

    renderProducts(products) {
      this.grid.innerHTML = '';
      products.forEach((p, i) => {
        const v = p.variants.find(v => v.available) || p.variants[0];
        const img = p.images[0] ? p.images[0].src : '';
        const imgSized = img ? img.replace(/(\.(jpe?g|png|webp|gif))(\?|$)/, '_540x$1$3') : '';
        const price = this.fmt(v.price);
        const comp = v.compare_at_price;
        const hasSave = comp && comp > v.price;
        const saveAmt = hasSave ? this.fmt(comp - v.price) : '';
        const pairNote = this.getPairNote(p);
        const delay = (i * 0.09).toFixed(2);

        this.grid.insertAdjacentHTML('beforeend',
          '<div class="mn-ctl-card" '
          + 'data-variant-id="' + v.id + '" '
          + 'data-price="' + v.price + '" '
          + 'data-compare="' + (comp || 0) + '" '
          + 'data-title="' + p.title.replace(/"/g, '&quot;') + '" '
          + 'data-img="' + imgSized + '" '
          + 'style="animation-delay:' + delay + 's">'
          + '<div class="mn-ctl-card-media">'
          + (img ? '<img class="mn-ctl-card-img" src="' + imgSized + '" alt="' + p.title.replace(/"/g,'') + '" loading="lazy">' : '<div style="width:100%;height:100%;background:#f0ead6"></div>')
          + '<div class="mn-ctl-badge">'
          + (hasSave ? '<span class="mn-ctl-badge-save">Save ' + saveAmt + '</span>' : '')
          + '<span class="mn-ctl-badge-stylist"><svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg> Stylist Pick</span>'
          + '</div>'
          + '<div class="mn-ctl-select-toggle"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>'
          + '<div class="mn-ctl-quick-add">'
          + '<span class="mn-ctl-qa-label">Pair With This Look</span>'
          + '<button class="mn-ctl-qa-btn" data-variant="' + v.id + '">Quick Add</button>'
          + '</div>'
          + '</div>'
          + '<div class="mn-ctl-card-info">'
          + '<p class="mn-ctl-card-type">' + (p.product_type || 'Accessory') + '</p>'
          + '<h3 class="mn-ctl-card-title">' + p.title + '</h3>'
          + '<div class="mn-ctl-card-price">'
          + '<span class="mn-ctl-price-now">' + price + '</span>'
          + (hasSave ? '<span class="mn-ctl-price-was">' + this.fmt(comp) + '</span>' : '')
          + '</div>'
          + (pairNote ? '<p class="mn-ctl-card-pair-note">' + pairNote + '</p>' : '')
          + '</div>'
          + '</div>'
        );
      });
      this.bindCards();
      this.initReveal();
    },

    getPairNote(p) {
      const t = (p.product_type || '').toLowerCase();
      const tags = (p.tags || []).join(' ').toLowerCase();
      if (/hijab|scarf/.test(t + tags)) return 'Drapes elegantly with this look';
      if (/sandal|heel|jutti|footwear|shoe/.test(t + tags)) return 'Completes the silhouette beautifully';
      if (/bag|clutch|purse|handbag/.test(t + tags)) return 'The perfect finishing touch';
      if (/jewel|necklace|earring|bangle/.test(t + tags)) return 'Adds a luxurious accent';
      if (/belt|sash/.test(t + tags)) return 'Defines the waist with elegance';
      if (/dupatta|stole/.test(t + tags)) return 'Pairs beautifully with this style';
      return 'Frequently styled together';
    },

    bindCards() {
      this.grid.querySelectorAll('.mn-ctl-card').forEach(card => {
        card.addEventListener('click', e => {
          if (e.target.closest('.mn-ctl-qa-btn')) return;
          this.toggleCard(card);
        });
        const qa = card.querySelector('.mn-ctl-qa-btn');
        if (qa) qa.addEventListener('click', e => {
          e.stopPropagation();
          this.quickAdd(qa.dataset.variant, qa);
        });
      });
    },

    toggleCard(card) {
      const vid = card.dataset.variantId;
      if (card.classList.contains('is-selected')) {
        card.classList.remove('is-selected');
        this.selected.delete(vid);
      } else {
        card.classList.add('is-selected');
        this.selected.set(vid, {
          variantId: vid,
          price: parseInt(card.dataset.price, 10),
          title: card.dataset.title,
          img: card.dataset.img
        });
      }
      this.updateBar();
    },

    updateBar() {
      if (this.selected.size === 0) {
        this.bar.classList.remove('is-visible');
        return;
      }
      let total = 0;
      const thumbs = [];
      this.selected.forEach(item => {
        total += item.price;
        thumbs.push(item.img);
      });
      const savings = this.discount > 0 ? Math.round(total * this.discount / 100) : 0;
      const final = total - savings;
      const count = this.selected.size;

      this.bar.querySelector('.mn-ctl-bb-thumbs').innerHTML =
        thumbs.slice(0,3).map(s => s ? '<img class="mn-ctl-bb-thumb" src="' + s + '" alt="">' : '').join('');
      this.bar.querySelector('.mn-ctl-bb-count').textContent = count + ' item' + (count > 1 ? 's' : '') + ' selected';
      const savEl = this.bar.querySelector('.mn-ctl-bb-savings');
      savEl.textContent = savings > 0 ? 'Bundle saving: ' + this.fmt(savings) : '';
      savEl.style.display = savings > 0 ? '' : 'none';
      this.bar.querySelector('.mn-ctl-bb-total-price').textContent = this.fmt(final);
      this.bar.classList.add('is-visible');
    },

    bindBar() {
      this.bar.querySelector('.mn-ctl-bb-cta').addEventListener('click', () => this.addBundle());
      const x = this.bar.querySelector('.mn-ctl-bb-close');
      if (x) x.addEventListener('click', () => {
        this.selected.clear();
        this.grid.querySelectorAll('.mn-ctl-card.is-selected').forEach(c => c.classList.remove('is-selected'));
        this.bar.classList.remove('is-visible');
      });
    },

    async addBundle() {
      const cta = this.bar.querySelector('.mn-ctl-bb-cta');
      if (!this.selected.size || cta.disabled) return;
      cta.disabled = true;
      cta.textContent = 'Adding…';
      const items = [];
      this.selected.forEach((item, vid) => items.push({ id: parseInt(vid, 10), quantity: 1 }));
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!r.ok) throw new Error();
        cta.textContent = '✓ The Look Is In Your Cart';
        this.refreshCart();
        setTimeout(() => { cta.textContent = 'Add The Look'; cta.disabled = false; }, 3200);
      } catch(e) {
        cta.textContent = 'Try Again';
        cta.disabled = false;
        setTimeout(() => { cta.textContent = 'Add The Look'; }, 2000);
      }
    },

    async quickAdd(vid, btn) {
      const orig = btn.textContent;
      btn.classList.add('is-adding');
      btn.textContent = '…';
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        });
        if (!r.ok) throw new Error();
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        btn.textContent = '✓ Added';
        this.refreshCart();
        setTimeout(() => { btn.classList.remove('is-added'); btn.textContent = orig; }, 2600);
      } catch(e) {
        btn.classList.remove('is-adding');
        btn.textContent = 'Try again';
        setTimeout(() => { btn.textContent = orig; }, 2000);
      }
    },

    refreshCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      const bubble = document.querySelector('[data-cart-icon-bubble]');
      if (bubble) bubble.dispatchEvent(new Event('click', { bubbles: true }));
    },

    initReveal() {
      if (!window.IntersectionObserver) {
        this.grid.querySelectorAll('.mn-ctl-card').forEach(c => c.classList.add('is-visible'));
        return;
      }
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
      }, { threshold: 0.08 });
      this.grid.querySelectorAll('.mn-ctl-card').forEach(c => io.observe(c));
    },

    showEmpty() {
      this.grid.innerHTML = '';
      const el = this.section.querySelector('.mn-ctl-empty');
      if (el) el.style.display = 'block';
    },

    fmt(cents) {
      if (!cents) return '₹0';
      return '₹' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => CTL.init());
  } else {
    CTL.init();
  }
})();
